// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ControlsTypes } from '@front/controls/UtilsClasses/FactoryConstants';
import { TerceraTextBox } from '@front/controls/elements/TerceraTextBox';
import InvestingTextBoxTemplate from '../../TradingPlatformTemplates/InvestingTextBoxTemplate.html';
export class InvestingTextBox extends TerceraTextBox {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.InvestingTextBox;
    }
    oninit() {
        super.oninit();
        this.observe('text', this.private_textChange);
    }
    private_textChange(newText, oldText) {
        super.private_textChange(newText, oldText);
        if (newText.length) {
            void this.set('visibleTitlePlaceholder', true);
        }
        else {
            void this.set('visibleTitlePlaceholder', false);
        }
    }
}
TerceraTextBox.extendWith(InvestingTextBox, {
    template: InvestingTextBoxTemplate,
    data: function () {
        return {
            visibleTitlePlaceholder: false,
            maxLength: 200, // максимальная длинна
            isReadOnly: false, // редактируемое поле
            placeholder: '', // текст внутри поля формы, который исчезает при получении фокуса
            text: '', // значение
            inputPatern: null, // патерн допустимых элементов g - флаг не использовать!  пример new RegExp('[1-9]')
            inputType: 'text',
            haveError: false,
            autofocus: false
        };
    }
});
